import script from "./DeviceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceTable.vue?vue&type=script&setup=true&lang=js"

import "./DeviceTable.vue?vue&type=style&index=0&id=ff7caa54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff7caa54"]])

export default __exports__